var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home[data-v-28cacb62]{background:url(" + escape(require("../assets/images/home3.jpg")) + ") no-repeat 0 0/cover;background-attachment:fixed;position:relative;background-position:0 0}.home .main[data-v-28cacb62]{position:fixed;top:calc(50% - 50px);left:20px;color:#fff}.home .main p[data-v-28cacb62]{font:700 23px/28px Noto Sans KR,sans-serif}.home .main h2[data-v-28cacb62]{font:700 45px/54px Roboto,sans-serif;margin:10px 0}.home .main h2 span[data-v-28cacb62]{color:#548df8}.home .main h3[data-v-28cacb62]{font:300 23px/28px Roboto,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28cacb62","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home.vue
// module id = 37
// module chunks = 0